import '../utils/testMobile'
import { redirectToAppMobile } from '../utils/redirectToApp'

export const REDIRECT_MOBILE = 'REDIRECT_MOBILE'
export const redirectMobile = () => (dispatch, getState) => {
	if (window.mobilecheck() && !getState().redirectMobile) {
		redirectToAppMobile(window.location.pathname.substr(1))
		dispatch({ type: REDIRECT_MOBILE })
	}
}



// WEBPACK FOOTER //
// ./src/redirectmobile/redirectMobileAction.js